import { useCallback } from "react";
import useSWR from "swr";
import { apiFetch, swrFetcher, type UserPreferences } from "@/lib/api";

export function usePreferences() {
  const { data, error, isLoading, mutate } = useSWR<UserPreferences>(
    "/api/auth/preferences",
    swrFetcher
  );

  const update = useCallback(
    async (patch: Partial<UserPreferences>) => {
      const next = await apiFetch<UserPreferences>("/api/auth/preferences", {
        method: "PATCH",
        body: JSON.stringify(patch),
      });
      await mutate(next, false);
      return next;
    },
    [mutate]
  );

  return { preferences: data, error, isLoading, update };
}
